module.exports = __webpack_public_path__ + "img/bg@2x.c7ab6906.png";